import { Component, OnInit } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { GetUserDetails, GetUserImage } from '../store/user-managment.actions';
import { ActivatedRoute } from '@angular/router';
import { BASE_URL } from 'src/app/services/Api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-users-details',
  templateUrl: './users-details.component.html',
  styleUrls: ['./users-details.component.scss']
})
export class UserDetailsComponent implements OnInit {
  id: string = ''
  userDetails: any = {}
  userImage: any
  userProfileImage: string;
  onlyRead: boolean= true;
  citiisV1CheckValue:boolean=false;
  citiisV2CheckValue:boolean=false;
  constructor(
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('id')
    this.userProfileImage = `${environment.host}/user/getImage/${this.id}`
   
    
    // get user details
    this.store.dispatch(new GetUserDetails(this.id));
    this.store.select(state => state.userManagment.userDetails)
      .subscribe(response => {
        this.userDetails = response;
        this.citiisV1CheckValue=this.userDetails.cities_1_flag;
        this.citiisV2CheckValue=this.userDetails.cities_2_flag;
        // this.citiisV1CheckValue=true;
      }, error => {
        console.log(error)
      })

    // to get the image
    // this.store.dispatch(new GetUserImage(this.id))
    // this.userImage = this.store.select(state => state.userManagment.userImage)
    //   .subscribe(response => {
    //     console.log(response)
    //     return response
    //   }, error => {
    //     console.log(error)
    //   })

  }

  setDefaultPic() {
    this.userProfileImage = "assets/images/user-details-icon.svg";
  }
  
}
